const time = {
  fromIso8601ToMs: (input: string) => parseFloat(input.slice(2, -1)) * 1000, // convert ISO8601 string to milliseconds
  toIso8601FromMs: (input: number) => `PT${input / 1000}S`, // convert milliseconds to ISO8601 string
};

export default time;
